import React from "react";
import styled from "@emotion/styled";
import withTranslator from "../Translator/withTranslation";
import withFosRouter from "../FosRouter/withFosRouting";
import { compose } from "recompose";

const PopupContainer = styled.div`
    z-index: 300;
    max-width: 600px;
`;

const CloseButton = styled.button`
    align-self: start;
    line-height: .8em
`;

class JustBookedComponent extends React.Component {
    constructor(props) {
        super(props);
                
        this.state = {
            popup: false
        };
    }
    
    componentDidMount(){
        if(!this.props.mobile) this.checkBookings();
    }
    
    checkBookings = () => {
        const { r } = this.props;
        var host = window.location.hostname,
            $parent = this;
        
        if (!host.match(/booking/g)) {
            setInterval(function () {
                var route = r('checkbookings');
                
                fetch(route)
                    .then(response => response.json())
                    .then(data => {
                        if (data.length !== 0) {
                            $parent.buildPopup(data);
                        }
                    })
            }, 15000, $parent);
        }
    }
    
    buildPopup = (data) => {
        const { t } = this.props;
        const text = [
            t('villa'),
            t('wasjustbooked'),
            t('showthisvilla')
        ];
        
        const popup = (
            <PopupContainer className="fixed bottom-4 right-4 bg-white transition-1 children-blue1 p-4">
                <div className="flex items-center">
                    <a href={data.villaLink}>
                        <img 
                        src={"https://www.clubvillamar.com"+data.villaImage} 
                        alt="house"
                        className="block"
                        />
                    </a>
                    <div className="font-90 mx-2">
                        <div>{text[0]} {data.villaName} {text[1]}</div>
                        <div className="flex items-center font-90">
                            <img src={"/assets/img/front/icons/flag-" + data.locale + ".svg"} alt="flag" width="16" height="16" className="mr-2"/>
                            <em>{data.country}, {t('timeago', {'time':data.bookedAt})}</em>
                        </div>
                        <div className="mt-2 text-right">
                            <a 
                                className="btn btn-primary btn-sm" 
                                href={data.villaLink}>
                                <span>{text[2]}</span>
                            </a>
                        </div>
                    </div>
                    <CloseButton 
                        className="btn-no bg-no bor-no font-150"
                        onClick={() => this.setState({popup:false})}
                    >&times;</CloseButton>
                </div>
            </PopupContainer>
        );

        this.setState({
            popup: popup
        });
        
        const $parent = this;
        
        setTimeout(function(){
            $parent.setState({
                popup: false
            });
        },15000,$parent);
    }
    
    render(){
        if(!this.state.popup) return (null);
        
        return this.state.popup;
    }
}


export const JustBooked = compose(
    withTranslator,
    withFosRouter
)(JustBookedComponent);